/**
 * Runtime widget for recently edited concept pages.
 */
Vue.asyncComponent('cms-dashboard-concept-pages', {
    props: {
        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        items: {
            type: Array,
            default: () => [],
        },
        moreHref: {
            type: String,
            default: '',
        },
        moreLabel: {
            type: String,
            default: '',
        },
        emptyText: {
            type: String,
            default: '',
        },
    },
}, 'cms/dashboard/live/cms-dashboard-concept-pages.html');
